import { buildTitleOfficerCard } from '../../shared';

export const titleOfficerContactCard = buildTitleOfficerCard();
